var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.154 0.15675L0 1.31075V3.68975L1.154 4.84375C1.363 5.05275 1.702 5.05275 1.911 4.84375L3.876 2.87875C4.085 2.66975 4.085 2.33075 3.876 2.12175L1.911 0.15675C1.702 -0.05225 1.363 -0.05225 1.154 0.15675Z",
    fill: "#799088"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35304 7.04184L4.50704 8.19584H6.88604L8.04004 7.04184C8.24904 6.83284 8.24904 6.49384 8.04004 6.28484L6.07504 4.31984C5.86604 4.11084 5.52704 4.11084 5.31804 4.31984L3.35304 6.28484C3.14404 6.49384 3.14404 6.83284 3.35304 7.04184Z",
    fill: "#799088"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2391 4.84375L11.3931 3.68975V1.31075L10.2391 0.15675C10.0301 -0.05225 9.6911 -0.05225 9.4821 0.15675L7.5171 2.12175C7.3081 2.33075 7.3081 2.66975 7.5171 2.87875L9.4821 4.84375C9.6911 5.05275 10.0301 5.05275 10.2391 4.84375Z",
    fill: "#799088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.d56faaafbd177a00ad82900b13123a8c.svg";
export { ForwardRef as ReactComponent };